import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import ModalContainer from 'app/components/shared/Modal/ModalContainer';
import FeedbackForm from './FeedbackForm';

export default class FeedbackModal extends React.PureComponent {
  render() {
    return (
      <ModalContainer className="cp-feedback-modal" handleClose={this.props.handleClose} modalKey={this.props.modalKey}>
        <FeedbackForm {...this.props} />
      </ModalContainer>
    );
  }
}

FeedbackModal.propTypes = {
  handleClose: PropTypes.func.isRequired,
  modalKey: PropTypes.string.isRequired,
  previewActions: PropTypes.objectOf(PropTypes.func),
  previewTransactions: ImmutablePropTypes.map.isRequired
};
